module.exports = __webpack_public_path__ + "img/stock3.209e650d.png";